'use client';
import { redirect } from 'next/navigation';
import { getDefaultLang } from '@/locale/utils';
import { isBrowser } from '@spot-fe/utils';
import { PATHS_SUPPORT } from '@/config';

export default function NotFound() {
  if (isBrowser) {
    const pathname = location.pathname;
    const defaultLang = getDefaultLang();

    if (PATHS_SUPPORT.includes(pathname)) {
      const path = `${pathname}${location.search}`;
      redirect(`/${defaultLang}${path}`);
    } else {
      redirect(`/${defaultLang}/${PATHS_SUPPORT[0]}`);
    }
  }
  return <></>;
}
